export const state = {
	users: [],
	currentUser: {},
	referrals: [],
	selectedUser: {},
};
